/* eslint-disable react-hooks/exhaustive-deps */
import { useDispatch, useSelector } from "react-redux";
import { selectCurrentUserApiToken, selectCurrentUserM11Use } from "../../slices/currentUser/currentUserSlice";
import {
    m11ReportContainerFoiChanged, m11ReportContainerResourceChanged,
    m11ReportSection04FoiChanged, m11ReportSection04ResourceChanged, selectM11ReportContainerFoi,
    selectM11ReportContainerResource, selectM11ReportSection04Foi, selectM11ReportSection04Resource,
    selectM11ResearchStudyResource
} from "../../slices/m11ReportAuthoringTool/m11ReportAuthoringToolSlice";
import { useEffect, useState, useImperativeHandle, forwardRef } from "react";
import jsonEquals from "../../functions/jsonEquals";
import getIdFromReference from "../../functions/getIdFromReference";
import loadResource from "../m11ReportFunctions/loadResource";
import TextDivEntry from "./TextDivEntry";
import CodeEntry from "../../datatypeComponents/CodeEntry";
import saveM11Changes from "../../functions/saveM11ChangesAPI";
import { selectM11ResearchStudyFoi } from "../../slices/m11StepCount/m11StepCountSlice";
import { validateStep } from "../../functions/validateM11ReportAPI";

const saveTrialDesignChanges = async (dispatch, apiToken, m11ResearchStudyFoi,
    section04State, setAlertModalState, setStartingSection04State) => {

    let changesStates = {
        section04State: section04State
    };
    let response = await saveM11Changes(apiToken, 20, m11ResearchStudyFoi, changesStates);
    if (response?.success) {
        if (response.m11ReportContainerResource) {
            dispatch(m11ReportContainerResourceChanged(response.m11ReportContainerResource));
        }
        if (response.m11ReportSection04Resource) {
            dispatch(m11ReportSection04ResourceChanged(response.m11ReportSection04Resource));
        }
        setStartingSection04State(JSON.parse(JSON.stringify(section04State)));
    } else {
        if (response.error) {
            alert(response.error);
        }
    }
};

const M11Step020TrialDesign = forwardRef(({ theM11ResearchStudyFoi, setAlertModalState }, ref) => {

    const dispatch = useDispatch();
    const apiToken = useSelector(selectCurrentUserApiToken);
    const m11User = useSelector(selectCurrentUserM11Use);
    const m11ResearchStudyResource = useSelector(selectM11ResearchStudyResource);
    const m11ReportContainerFoi = useSelector(selectM11ReportContainerFoi);
    const m11ReportContainerResource = useSelector(selectM11ReportContainerResource);
    const m11ReportSection04Foi = useSelector(selectM11ReportSection04Foi);
    const m11ReportSection04Resource = useSelector(selectM11ReportSection04Resource);
    const m11ResearchStudyFoi = useSelector(selectM11ResearchStudyFoi);

    const [section04State, setSection04State] = useState({
        "section41Status": "empty", "section41Xhtml": "",
        "lumpOrSplit": "",
        "section42Status": "empty", "section42Xhtml": "",
        "section421Status": "empty", "section421Xhtml": "",
        "section422Status": "empty", "section422Xhtml": "",
        "section423Status": "empty", "section423Xhtml": "",
        "section424Status": "empty", "section424Xhtml": "",
        "section425Status": "empty", "section425Xhtml": "",
        "section426Status": "empty", "section426Xhtml": "",
        "section427Status": "empty", "section427Xhtml": "",
        "section43Status": "empty", "section43Xhtml": "",
        "section44Status": "empty", "section44Xhtml": "",
        "section45Status": "empty", "section45Xhtml": ""
    });
    const [startingSection04State, setStartingSection04State] = useState({
        "section41Status": "empty", "section41Xhtml": "",
        "lumpOrSplit": "",
        "section42Status": "empty", "section42Xhtml": "",
        "section421Status": "empty", "section421Xhtml": "",
        "section422Status": "empty", "section422Xhtml": "",
        "section423Status": "empty", "section423Xhtml": "",
        "section424Status": "empty", "section424Xhtml": "",
        "section425Status": "empty", "section425Xhtml": "",
        "section426Status": "empty", "section426Xhtml": "",
        "section427Status": "empty", "section427Xhtml": "",
        "section43Status": "empty", "section43Xhtml": "",
        "section44Status": "empty", "section44Xhtml": "",
        "section45Status": "empty", "section45Xhtml": ""
    });
    const [initialCalculationNeeded, setInitialCalculationNeeded] = useState(false);

    useImperativeHandle(ref, () => ({
        unsavedChanges: (m11ResearchStudyResource && !jsonEquals(section04State, startingSection04State)),
        async saveAllChanges() {
            await saveTrialDesignChanges(dispatch, apiToken, m11ResearchStudyFoi,
                section04State, setAlertModalState, setStartingSection04State);
        }
    }));

    useEffect(() => {
        if (m11ResearchStudyResource?.id) {
            let m11ReportFoi = "";
            if (m11ResearchStudyResource.relatesTo?.length > 0) {
                for (let relatesTo of m11ResearchStudyResource.relatesTo) {
                    if (relatesTo.type?.coding?.[0]?.code === "supported-with" && relatesTo.type.text === "M11 Report" &&
                        relatesTo.targetReference) {
                        m11ReportFoi = getIdFromReference(relatesTo.targetReference);
                    }
                }
            }
            if (m11ReportFoi && !isNaN(m11ReportFoi) && m11ReportFoi !== m11ReportContainerFoi) {
                dispatch(m11ReportContainerFoiChanged(m11ReportFoi));
            } else {
                setInitialCalculationNeeded(true);
            }
        }
    }, [m11ResearchStudyResource]);

    useEffect(() => {
        if (initialCalculationNeeded === true) {
            let startingData = {
                "section41Status": "empty", "section41Xhtml": "",
                "lumpOrSplit": "",
                "section42Status": "empty", "section42Xhtml": "",
                "section421Status": "empty", "section421Xhtml": "",
                "section422Status": "empty", "section422Xhtml": "",
                "section423Status": "empty", "section423Xhtml": "",
                "section424Status": "empty", "section424Xhtml": "",
                "section425Status": "empty", "section425Xhtml": "",
                "section426Status": "empty", "section426Xhtml": "",
                "section427Status": "empty", "section427Xhtml": "",
                "section43Status": "empty", "section43Xhtml": "",
                "section44Status": "empty", "section44Xhtml": "",
                "section45Status": "empty", "section45Xhtml": "",
                "loaded": true
            };
            setSection04State(startingData);
            setStartingSection04State(startingData);
        }
    }, [initialCalculationNeeded]);

    useEffect(() => {
        if (m11ReportContainerFoi && !isNaN(m11ReportContainerFoi)) {
            loadResource(m11ReportContainerFoi, "M11ReportContainer", apiToken, dispatch);
        }
    }, [m11ReportContainerFoi]);

    useEffect(() => {
        if (m11ReportContainerResource && Object.keys(m11ReportContainerResource).length > 0) {
            if (m11ReportContainerResource.section?.[4]?.entry?.length) {
                let m11ReportSection004Foi = getIdFromReference(m11ReportContainerResource.section[4].entry[0]);
                if (m11ReportSection004Foi && !isNaN(m11ReportSection004Foi) && m11ReportSection004Foi !== m11ReportSection04Foi) {
                    dispatch(m11ReportSection04FoiChanged(m11ReportSection004Foi));
                } else {
                    setInitialCalculationNeeded(true);
                }
            } else {
                setInitialCalculationNeeded(true);
            }
        }
    }, [m11ReportContainerResource]);

    useEffect(() => {
        if (m11ReportSection04Foi && !isNaN(m11ReportSection04Foi)) {
            loadResource(m11ReportSection04Foi, "M11ReportSection04", apiToken, dispatch);
        }
    }, [m11ReportSection04Foi]);

    useEffect(() => {
        if (m11ReportSection04Resource && Object.keys(m11ReportSection04Resource).length > 0) {
            let startingData = {
                "section41Status": "empty", "section41Xhtml": "",
                "lumpOrSplit": "",
                "section42Status": "empty", "section42Xhtml": "",
                "section421Status": "empty", "section421Xhtml": "",
                "section422Status": "empty", "section422Xhtml": "",
                "section423Status": "empty", "section423Xhtml": "",
                "section424Status": "empty", "section424Xhtml": "",
                "section425Status": "empty", "section425Xhtml": "",
                "section426Status": "empty", "section426Xhtml": "",
                "section427Status": "empty", "section427Xhtml": "",
                "section43Status": "empty", "section43Xhtml": "",
                "section44Status": "empty", "section44Xhtml": "",
                "section45Status": "empty", "section45Xhtml": "",
                "loaded": true
            };
            if (m11ReportSection04Resource.section?.[0]?.section?.length > 0) {
                if (m11ReportSection04Resource.section[0].section[0]?.text?.div &&
                    m11ReportSection04Resource.section[0].section[0].text.status !== "empty") {
                    startingData.section41Status = m11ReportSection04Resource.section[0].section[0].text.status;
                    startingData.section41Xhtml = m11ReportSection04Resource.section[0].section[0].text.div;
                }
                if (m11ReportSection04Resource.section[0].section[0]?.section?.[0].text?.div &&
                    m11ReportSection04Resource.section[0].section[0].section[0].text.status !== "empty") {
                    startingData.section411Status = m11ReportSection04Resource.section[0].section[0].section[0].text.status;
                    startingData.section411Xhtml = m11ReportSection04Resource.section[0].section[0].section[0].text.div;
                }
                if (m11ReportSection04Resource.section[0].section[1]?.text?.div &&
                    m11ReportSection04Resource.section[0].section[1].text.status !== "empty") {
                    startingData.section42Status = m11ReportSection04Resource.section[0].section[1].text.status;
                    startingData.section42Xhtml = m11ReportSection04Resource.section[0].section[1].text.div;
                    startingData.lumpOrSplit = "Lump";
                }
                if (m11ReportSection04Resource.section[0].section[1]?.section?.length > 0) {
                    if (m11ReportSection04Resource.section[0].section[1].section[0]?.text?.div &&
                        m11ReportSection04Resource.section[0].section[1].section[0].text.status !== "empty") {
                        startingData.section421Status = m11ReportSection04Resource.section[0].section[1].section[0].text.status;
                        startingData.section421Xhtml = m11ReportSection04Resource.section[0].section[1].section[0].text.div;
                        startingData.lumpOrSplit = "Split";
                    }
                    if (m11ReportSection04Resource.section[0].section[1].section?.[1]?.text?.div &&
                        m11ReportSection04Resource.section[0].section[1].section[1].text.status !== "empty") {
                        startingData.section422Status = m11ReportSection04Resource.section[0].section[1].section[1].text.status;
                        startingData.section422Xhtml = m11ReportSection04Resource.section[0].section[1].section[1].text.div;
                    }
                    if (m11ReportSection04Resource.section[0].section[1].section?.[2]?.text?.div &&
                        m11ReportSection04Resource.section[0].section[1].section[2].text.status !== "empty") {
                        startingData.section423Status = m11ReportSection04Resource.section[0].section[1].section[2].text.status;
                        startingData.section423Xhtml = m11ReportSection04Resource.section[0].section[1].section[2].text.div;
                    }
                    if (m11ReportSection04Resource.section[0].section[1].section[3]?.text?.div &&
                        m11ReportSection04Resource.section[0].section[1].section[3].text.status !== "empty") {
                        startingData.section424Status = m11ReportSection04Resource.section[0].section[1].section[3].text.status;
                        startingData.section424Xhtml = m11ReportSection04Resource.section[0].section[1].section[3].text.div;
                    }
                    if (m11ReportSection04Resource.section[0].section[1].section[4]?.text?.div &&
                        m11ReportSection04Resource.section[0].section[1].section[4].text.status !== "empty") {
                        startingData.section425Status = m11ReportSection04Resource.section[0].section[1].section[4].text.status;
                        startingData.section425Xhtml = m11ReportSection04Resource.section[0].section[1].section[4].text.div;
                    }
                    if (m11ReportSection04Resource.section[0].section[1].section[5]?.text?.div &&
                        m11ReportSection04Resource.section[0].section[1].section[5].text.status !== "empty") {
                        startingData.section426Status = m11ReportSection04Resource.section[0].section[1].section[5].text.status;
                        startingData.section426Xhtml = m11ReportSection04Resource.section[0].section[1].section[5].text.div;
                    }
                    if (m11ReportSection04Resource.section[0].section[1].section[6]?.text?.div &&
                        m11ReportSection04Resource.section[0].section[1].section[6].text.status !== "empty") {
                        startingData.section427Status = m11ReportSection04Resource.section[0].section[1].section[6].text.status;
                        startingData.section427Xhtml = m11ReportSection04Resource.section[0].section[1].section[6].text.div;
                    }
                }
                if (m11ReportSection04Resource.section[0].section[2]?.text?.div &&
                    m11ReportSection04Resource.section[0].section[2].text.status !== "empty") {
                    startingData.section43Status = m11ReportSection04Resource.section[0].section[2].text.status;
                    startingData.section43Xhtml = m11ReportSection04Resource.section[0].section[2].text.div;
                }
                if (m11ReportSection04Resource.section[0].section[3]?.text?.div &&
                    m11ReportSection04Resource.section[0].section[3].text.status !== "empty") {
                    startingData.section44Status = m11ReportSection04Resource.section[0].section[3].text.status;
                    startingData.section44Xhtml = m11ReportSection04Resource.section[0].section[3].text.div;
                }
                if (m11ReportSection04Resource.section[0].section[4]?.text?.div &&
                    m11ReportSection04Resource.section[0].section[4].text.status !== "empty") {
                    startingData.section45Status = m11ReportSection04Resource.section[0].section[4].text.status;
                    startingData.section45Xhtml = m11ReportSection04Resource.section[0].section[4].text.div;
                }
                setSection04State(startingData);
                setStartingSection04State(startingData);
            } else {
                setInitialCalculationNeeded(true);
            }
        }
    }, [m11ReportSection04Resource]);

    return <div>
        <h3>Complete Section 4 Trial Design</h3>
        {!(m11ReportSection04Resource?.id || m11ReportContainerResource?.id) &&
            <h1 style={{ color: "red" }}>Please complete Step 5 (Complete Title Page) before filling in M11 Report Section details.</h1>
        }
        {m11User === "sample" ?
            <div style={{ outline: "1px solid #000000", padding: "6px", width: "fit-content" }}>
                <h2>You are using the M11 Report Authoring Tool (Test Drive Version).</h2>
                <p style={{ color: "red" }}>Step 20 (Complete Section 4 Trial Design) is not included in the M11 Report Authoring Tool (Test Drive Version).</p>
                <p>Subscribe to the M11 Report Authoring Tool (Professional Version) for complete functionality.</p>
            </div>
            :
            <>
                {section04State.loaded && <>
                    <h4 style={{ marginBottom: "0px" }}>Revise the Section 4.1 Description of Trial Design summary as needed.</h4>
                    <TextDivEntry elementName="section41Xhtml"
                        startingValue={section04State.section41Xhtml}
                        setResourceState={setSection04State} />
                    <h4 style={{ marginBottom: "0px" }}>Revise the Section 4.1.1 Stakeholder Input into Design summary as needed.</h4>
                    <TextDivEntry elementName="section411Xhtml"
                        startingValue={section04State.section411Xhtml}
                        setResourceState={setSection04State} />
                    <h4 style={{ marginBottom: "0px" }}>Revise the Section 4.2 Rationale for Trial Design summary as needed.</h4>
                    {section04State.lumpOrSplit === "Lump" ?
                        <TextDivEntry elementName="section42Xhtml"
                            startingValue={section04State.section42Xhtml}
                            setResourceState={setSection04State} />
                        :
                        section04State.lumpOrSplit === "Split" ?
                            <>
                                <h5 style={{ marginBottom: "0px" }}>Revise the Section 4.2.1 Rationale for Estimand(s) as needed.</h5>
                                <TextDivEntry elementName="section421Xhtml"
                                    startingValue={section04State.section421Xhtml}
                                    setResourceState={setSection04State} />
                                <h5 style={{ marginBottom: "0px" }}>Revise the Section 4.2.2 Rationale for Intervention Model as needed.</h5>
                                <TextDivEntry elementName="section422Xhtml"
                                    startingValue={section04State.section422Xhtml}
                                    setResourceState={setSection04State} />
                                <h5 style={{ marginBottom: "0px" }}>Revise the Section 4.2.3 Rationale for Control Type as needed.</h5>
                                <TextDivEntry elementName="section423Xhtml"
                                    startingValue={section04State.section423Xhtml}
                                    setResourceState={setSection04State} />
                                <h5 style={{ marginBottom: "0px" }}>Revise the Section 4.2.4 Rationale for Trial Duration as needed.</h5>
                                <TextDivEntry elementName="section424Xhtml"
                                    startingValue={section04State.section424Xhtml}
                                    setResourceState={setSection04State} />
                                <h5 style={{ marginBottom: "0px" }}>Revise the Section 4.2.5 Rationale for Adaptive or Novel Trial Design as needed.</h5>
                                <TextDivEntry elementName="section425Xhtml"
                                    startingValue={section04State.section425Xhtml}
                                    setResourceState={setSection04State} />
                                <h5 style={{ marginBottom: "0px" }}>Revise the Section 4.2.6 Rationale for Interim Analysis as needed.</h5>
                                <TextDivEntry elementName="section426Xhtml"
                                    startingValue={section04State.section426Xhtml}
                                    setResourceState={setSection04State} />
                                <h5 style={{ marginBottom: "0px" }}>Revise the Section 4.2.7 Rationale for Other Trial Design Aspects as needed.</h5>
                                <TextDivEntry elementName="section427Xhtml"
                                    startingValue={section04State.section427Xhtml}
                                    setResourceState={setSection04State} />
                            </>
                            :
                            <>
                                <h5 style={{ marginBottom: "0px" }}>DECIDE whether to summarize as one section (Lump) or multiple subsections (Split).</h5>
                                <CodeEntry elementName='lumpOrSplit' fieldLabel='Lump or Split'
                                    startingValue={section04State.lumpOrSplit} setResourceState={setSection04State}
                                    allowedValues={["Lump", "Split"]} />
                            </>
                    }
                    <h4 style={{ marginBottom: "0px" }}>Revise the Section 4.3 Trial Stopping Rules summary as needed.</h4>
                    <TextDivEntry elementName="section43Xhtml"
                        startingValue={section04State.section43Xhtml}
                        setResourceState={setSection04State} />
                    <h4 style={{ marginBottom: "0px" }}>Revise the Section 4.4 Start of Trial and End of Trial summary as needed.</h4>
                    <TextDivEntry elementName="section44Xhtml"
                        startingValue={section04State.section44Xhtml}
                        setResourceState={setSection04State} />
                    <h4 style={{ marginBottom: "0px" }}>Revise the Section 4.5 Access to Trial Intervention After End of Trial summary as needed.</h4>
                    <TextDivEntry elementName="section45Xhtml"
                        startingValue={section04State.section45Xhtml}
                        setResourceState={setSection04State} />
                </>}
            </>
        }
    </div >
});

const M11Step020TrialDesignHelperText = <div>
    <h3>Complete Section 4 Trial Design</h3>
    <div style={{ textAlign: "left" }}>
        <p>Enter data for Section 4.1 Description of Trial Design.</p>
        <div style={{ marginLeft: "24px" }} >
            <p>Describe the overall trial design and intervention model (e.g., single group, parallel group, cross-over, factorial, sequential), the expected number of participants, and the control method (e.g., placebo, active comparator, low dose, external, standard of care, sham procedure, or none [uncontrolled]). If there are any key aspects of the investigational trial intervention that inform the selection of the intervention model, this should be described. If applicable, indicate other design characteristics (e.g., superiority, noninferiority, dose escalation, or equivalence). If the trial will have an adaptive or novel design (e.g., the trial will be conducted under a master protocol), provide a summary of these design aspects. If applicable, describe within-trial transition rules, e.g., transitions involving cohorts or trial parts. Dose escalation or dose-ranging details should also be described. Describe the trial duration with reference to Section 1.2 Trial Schema. Explain what the overall duration for an individual participant is anticipated to be and why, including the sequence and duration of trial periods (e.g., screening, run-in, randomisation, treatment [fixed dose/titration], follow-up/washout periods). Where applicable, include discussion of sentinel dosing (or lack thereof), dose escalation, and cohort expansion. If dose modification decisions are dependent upon review by a committee, include details in Section 11.4 Committees. State the method of assignment to trial intervention the level and method of blinding that will be used with reference to Section 6.7 Investigational Trial Intervention Assignment, Randomisation and Blinding. Describe any other important aspects of the design, e.g.: • geographic scope of trial (e.g., single-centre, multi-centre, or multi-centre and multi-national) • use of decentralised processes, tools, or features in the trial • planned use of a Data Monitoring Committee, or similar review group and cross reference Section 11.4 Committees, for details • whether an interim analysis is planned; if so, refer to details in Section 10.9 Interim Analyses • any planned extension trial, long-term follow-up/registry, planned future use of samples or data, or post-trial sample analysis or other data-related activities.</p>
        </div>
        <p>If applicable, enter data for Section 4.1.1 Stakeholder Input into Design.</p>
        <div style={{ marginLeft: "24px" }} >
            <p>If applicable, describe any stakeholder (for example, patient, healthcare professional and patient advocacy groups) involvement in the design of the trial and any suggestions implemented.</p>
        </div>
        <p>Enter data for Section 4.2 Rationale for Trial Design.</p>
        <div style={{ marginLeft: "24px" }} >
            <p>Enter Overall Rationale for Trial Design, if not using below optional subheadings.</p>
            <p>This section may be structured under one single heading, or if applicable under up to 7 subheadings.</p>
            <p>DECIDE WHETHER TO USE 1 SECTION OR 7 SUBSECTIONS. If using 1 section, enter the entire summary there and 'Save All Changes'.</p>
            <p>For Section 4.2.1 Rationale for Estimand(s): When estimands are associated with the Primary and Secondary Objectives described in Section 3 Trial Objectives and Associated Estimands, provide a rationale for the estimand(s) not described elsewhere in the document. This should include a rationale that the selected endpoint(s) are clinically relevant and provide a reliable and valid measurement of the intended intervention effect. It should also include a rationale for the selected strategies for handling intercurrent events.</p>
            <p>For Section 4.2.2 Rationale for Intervention Model: Provide a rationale for the trial intervention model described in Section 4.1 Description of Trial Design with a cross reference to Section 6.2 Rationale for Investigational Intervention Dose and Regimen. Rationale for choice of comparator, if applicable, should be described separately in Section 4.2.5 Rationale for Control Type. A rationale for the choice of trial population should be described separately in Section 5.1 Description of Trial Population and Rationale.</p>
            <p>For Section 4.2.3 Rationale for Control Type: If applicable, provide a rationale for the type and choice of control selected for the trial (e.g., placebo, active drug, combination, external). Describe any known or potential problems associated with the control group selected in light of the specific disease and intervention(s) being studied. If comparators will differ by region, describe. The rationale for dose/dose regimen is explained in Section 6.2 Rationale for Investigational Trial Intervention Dose and Regimen.</p>
            <p>For Section 4.2.4 Rationale for Trial Duration: Provide a rationale that the trial duration is appropriate for a reliable and relevant evaluation of the trial intervention per the trial objective(s).</p>
            <p>For Section 4.2.5 Rationale for Adaptive or Novel Trial Design: If applicable, provide a rationale for the use of an adaptive or novel design.</p>
            <p>For Section 4.2.6 Rationale for Interim Analysis: If applicable, provide a rationale for any interim analysis planned with respect to its purpose (for example, stopping the trial early for efficacy or futility) and timing.</p>
            <p>For Section 4.2.7 Rationale for Other Trial Design Aspects: Discuss rationale for any additional aspects of the design not addressed above.</p>
        </div>
        <p>If applicable, enter data for Section 4.3 Trial Stopping Rules.</p>
        <div style={{ marginLeft: "24px" }} >
            <p>If applicable, describe any trial-specific stopping rules, including guidance on when the trial should be stopped for safety reasons, when a cohort or dose escalation should be terminated, and/or when a given treatment arm should be terminated. If applicable, describe any rules that may result in a temporary pause of dosing and/or enrollment into the trial and criteria for restarting enrollment. Ensure that the trials stopping rules are aligned with the specifications that are described in Section 10.9 for Interim Analyses.</p>
        </div>
        <p>Enter data for Section 4.4 Start of Trial and End of Trial.</p>
        <div style={{ marginLeft: "24px" }} >
            <p>Define key timepoints in the trial, including trial start and end definitions (e.g., a key timepoint definition for start of trial might be when the informed consent is signed by the first participant and a key timepoint definition for end of trial might be when participants are no longer being examined or the last participant’s last trial assessment has occurred). Consider local regulatory requirements for these and other definitions (e.g., the first act of recruitment). If appropriate, provide a cross reference to Section 11.11 Early Site Closure.</p>
        </div>
        <p>If applicable, enter data for Section 4.5 Access to Trial Intervention After End of Trial.</p>
        <div style={{ marginLeft: "24px" }} >
            <p>If applicable, describe any possibilities for access to trial intervention, if any, beyond completion of the trial. Planned extension trials, if described in Section 4.1 Description of Trial Design, do not need to be repeated in this section.</p>
        </div>
        <p>Click the 'Save All Changes' button.</p>
    </div>
</div>

// eslint-disable-next-line no-empty-pattern
const M11Step020TrialDesignValidationCheck = ({ }) => {

    const apiToken = useSelector(selectCurrentUserApiToken);
    const m11ResearchStudyFoi = useSelector(selectM11ResearchStudyFoi);

    const [validationCheckState, setValidationCheckState] = useState({});

    useEffect(() => {
        if (m11ResearchStudyFoi) {
            validateStep(apiToken, 20, m11ResearchStudyFoi,
                setValidationCheckState)
        }
    }, [m11ResearchStudyFoi]);

    return <div>{validationCheckState?.success && <div>
        <h4>Step 20 (Complete Section 4 Trial Design) {validationCheckState.step20numberOfChecks} issues checked. {validationCheckState.step20numberPassed} passed. {validationCheckState.step20numberFailed} failed.</h4>
        <p>Section 4 heading is 'TRIAL DESIGN': {validationCheckState.resultCheckSection4Heading}</p>
        <p>Section 4 TRIAL DESIGN does not have text: {validationCheckState.resultCheckSection4Text}</p>
        <p>Section 4.1 heading is 'Description of Trial Design': {validationCheckState.resultCheckSection41Heading}</p>
        <p>Section 4.1 Description of Trial Design has content: {validationCheckState.resultCheckSection41Content}</p>
        <p>If present, section 4.1.1 heading is 'Stakeholder Input into Design': {validationCheckState.resultCheckSection411Heading}</p>
        <p>If present, section 4.1.1 Stakeholder Input into Design has content: {validationCheckState.resultCheckSection411Content}</p>
        <p>Section 4.2 heading is 'Rationale for Trial Design': {validationCheckState.resultCheckSection42Heading}</p>
        <p>Section 4.2 Rationale for Trial Design has content or subheadings: {validationCheckState.resultCheckSection42Content}</p>
        <p>If present, Section 4.2.1 heading is 'Rationale for Estimand(s)': {validationCheckState.resultCheckSection421Heading}</p>
        <p>If present, Section 4.2.1 Rationale for Estimand(s) has content: {validationCheckState.resultCheckSection421Content}</p>
        <p>If present, Section 4.2.2 heading is 'Rationale for Intervention Model': {validationCheckState.resultCheckSection422Heading}</p>
        <p>If present, Section 4.2.2 Rationale for Intervention Model has content: {validationCheckState.resultCheckSection422Content}</p>
        <p>If present, Section 4.2.3 heading is 'Rationale for Control Type': {validationCheckState.resultCheckSection423Heading}</p>
        <p>If present, Section 4.2.3 Rationale for Control Type has content: {validationCheckState.resultCheckSection423Content}</p>
        <p>If present, Section 4.2.4 heading is 'Rationale for Trial Duration': {validationCheckState.resultCheckSection424Heading}</p>
        <p>If present, Section 4.2.4 Rationale for Trial Duration has content: {validationCheckState.resultCheckSection424Content}</p>
        <p>If present, Section 4.2.5 heading is 'Rationale for Adaptive or Novel Design': {validationCheckState.resultCheckSection425Heading}</p>
        <p>If present, Section 4.2.5 Rationale for Adaptive or Novel Design has content: {validationCheckState.resultCheckSection425Content}</p>
        <p>If present, Section 4.2.6 heading is 'Rationale for Interim Analysis': {validationCheckState.resultCheckSection426Heading}</p>
        <p>If present, Section 4.2.6 Rationale for Interim Analysis has content: {validationCheckState.resultCheckSection426Content}</p>
        <p>If present, Section 4.2.7 heading is 'Rationale for Other Trial Design Aspects': {validationCheckState.resultCheckSection427Heading}</p>
        <p>If present, Section 4.2.7 Rationale for Other Trial Design Aspects has content: {validationCheckState.resultCheckSection427Content}</p>
        <p>Section 4.3 heading is 'Trial Stopping Rules': {validationCheckState.resultCheckSection43Heading}</p>
        <p>Section 4.3 Trial Stopping Rules has content: {validationCheckState.resultCheckSection43Content}</p>
        <p>Section 4.4 heading is 'Start of Trial and End of Trial': {validationCheckState.resultCheckSection44Heading}</p>
        <p>Section 4.4 Start of Trial and End of Trial has content: {validationCheckState.resultCheckSection44Content}</p>
        <p>Section 4.5 heading is 'Access to Trial Intervention After End of Trial': {validationCheckState.resultCheckSection45Heading}</p>
        <p>Section 4.5 Access to Trial Intervention After End of Trial has content: {validationCheckState.resultCheckSection45Content}</p>
    </div>}  </div>
}

export default M11Step020TrialDesign;
export { M11Step020TrialDesignHelperText, M11Step020TrialDesignValidationCheck };